<template>
  <div
    :style="{
      backgroundImage: 'url(' + bg + ')',
      backgroundPosition: 'center',
    }"
  >
    <v-container grid-list-lg>
      <v-layout wrap justify-center>
        <v-flex md10>
          <v-card class="pa-4 mb-2">
            <h4 class="accent--text">What is ELITE?</h4>
            <p class="body-2 mt-2 ml-3" style="ext-align: justify">
              As a physician, you are busy in your clinical practice, that
              attending trainings, seminars, or conferences to earn Continuing
              Professional Development (“CPD”) units may be a challenge. This
              ELITE Website provides the solution as it is an online learning
              platform on thyroid disorders that is accessible physicians in the
              Philippines.
            </p>
            <p class="body-2 mt-2 ml-3" style="ext-align: justify">
              The ELITE Website provides free CPD units to Filipino physicians
              with PRC ID who register and complete the modules as well as pass
              the online examination.
            </p>
          </v-card>
          <v-card class="pa-4 mb-2">
            <h4 class="accent--text">How to have full access?</h4>
            <p class="body-2 mt-2 ml-3" style="ext-align: justify">
              You must register in the ELITE Website to gain full access.
              Registration is simple and is done by providing the Professional
              Regulatory Commission (“PRC”) details such as the physician’s
              name, PRC registration number, date of registration and email
              address.
            </p>
          </v-card>
          <v-card class="pa-4 mb-2">
            <h4 class="accent--text">How to earn CPD units?</h4>
            <p class="body-2 mt-2 ml-3" style="ext-align: justify">
              After registering, the physician will have access to all modules
              on thyroid disorders, prediabetes and diabetes, and cardiovascular
              diseases. To earn a CPD point, one must finish the module and pass
              an online examination for each module.
            </p>
            <p class="body-2 mt-2 ml-3" style="ext-align: justify">
              The CPD unit provided by this website is for Filipino physicians
              who have PRC ID.
            </p>
          </v-card>
          <v-card class="pa-4 mb-2">
            <h4 class="accent--text">FAQs.</h4>
            <v-container class="ml-4">
              <ol>
                <li>
                  <strong class="accent--text"
                    >What will happen if the healthcare professional does not
                    pass the online examination for a module?</strong
                  >
                </li>
                <p class="body-2 mt-2">
                  The physician may take the online exam several times until one
                  passes.
                </p>
                <li>
                  <strong class="accent--text"
                    >Is there a possibility that PRC (or the applicable
                    regulatory agency) will not honor the units earned by the
                    healthcare professional?</strong
                  >
                </li>
                <p class="body-2 mt-2">
                  Yes, this is possible if the details provided by the physician
                  were incorrect, thus could not be verified by the applicable
                  regulatory agency.
                </p>
                <li>
                  <strong class="accent--text"
                    >Can the healthcare professional take the module and online
                    examination after s/he earned the CPD (or their relevant
                    equivalent) units to earn additional units?</strong
                  >
                </li>
                <p class="body-2 mt-2">
                  No. After earning gaining all the CPD units, the physician can
                  no longer earn additional units by viewing the module and
                  taking the online exam again. The units from these modules may
                  only be earned once.
                </p>
              </ol>
            </v-container>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
export default {
  data() {
    return {
      bg: require("@/assets/bg/water_6.png"),
    };
  },
};
</script>


// WEBPACK FOOTER //
// src/components/dashboard/aboutUs.vue